import { render, staticRenderFns } from "./trainingModulePageNew9.vue?vue&type=template&id=0ea39311&scoped=true&"
import script from "./trainingModulePageNew9.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew9.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew9.vue?vue&type=style&index=0&id=0ea39311&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea39311",
  null
  
)

export default component.exports